// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__qGnR_","select":"Header_select__1WPLD","clinic":"Header_clinic__pw5DS"};